/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    AbstractControl,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';

export const AVI_REPEATED_STRINGS_RANGE_VALIDATOR_KEY = 'aviRepeatedStringsRangeValidation';

/**
 * Returns validatorFunction for AviRepeatedStringsComponent.
 *
 * @author Aravindh Nagarajan
 */
export function aviRepeatedStringsRangeValidator(range: [number, number]): ValidatorFn {
    /**
     * Returns null if it's a valid value - i.e. value is within range.
     * Returns validationError otherwise.
     */
    return (control: AbstractControl): ValidationErrors | null => {
        const [min = 0, max = Infinity] = range;
        const { value } = control;

        if (!value) {
            return null;
        }

        const { length: valueCount } = value;

        const errorObject = {
            [AVI_REPEATED_STRINGS_RANGE_VALIDATOR_KEY]: valueCount,
        };

        if (valueCount < min || valueCount > max) {
            return errorObject;
        }

        return null;
    };
}
